<ng-container *ngIf="destinations$ | async as d">
  <span *ngIf="label" class="field-destination__label">{{ label | translate }}</span>
  <span *ngIf="d.pdf || d.freeVacancies" class="field-destination__chips">
    <span *ngIf="d.pdf" class="field-destination__chip field-destination__chip--pdf">PDF</span>
    <span *ngIf="d.freeVacancies" class="field-destination__chip field-destination__chip--fv">{{ 'FREE_VACANCIES.TITLE' | translate }}</span>
  </span>
</ng-container>
